import React from 'react'
import Parser from '../parser/Parser'

const TitleFloating = ({ block }) => {
    return (
        <div className="title-floating-block">
            {block?.content ? (
                <h3 className="!baseocom-text-xl !baseocom-mb-0">{block?.content}</h3>
            ) : null}
            {block?.childrens && <Parser content_block={block?.childrens} />}
        </div>
    )
}

export default TitleFloating
